import { IDictionary } from '../apps/dictionary.interface';
import { IAppCategory } from '../apps/IAppCategory.interface';

export interface IAppPromo {
  name: string;
  imageUrl: string;
  version: string;
  categories?: IAppCategory[];
  models?: IDictionary[];
  description?: string;
  modelFamiliesWithDeviceModels?: {
    [modelFamilyValue: string]: string[];
  };
}
